import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'

import './client.module.css'
import './components/var.module.css'
import './components/app.module.css'
import './components/gallery/index.module.css'
import './components/header/index.module.css'
import './components/person/index.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends HTMLElement {
  name = tag
}

safeDefine(tag, AppElement)
